import React, { useEffect, useState } from 'react'
import Dropdown from 'react-dropdown';
import 'react-dropdown/style.css';
import styles from './SearchBox.module.css'
import SearchDistrict from './SearchDistrict';

function SearchBox({setFilterCity, setFilterState}) {

    const [stateData,setStateData]=useState([]);
    const [state,setState]=useState();
    
    const [selectedDistrict,setSelectedDistrict] = useState('')

      useEffect(()=>{
        getData()
      },[])

      const getData=()=>{
        fetch('States.json'
        ,{
          headers : { 
            'Content-Type': 'application/json',
            'Accept': 'application/json'
           }
        }
        )
          .then((response) => {
            return response.json();
          })
          .then((myJson) => {
            setStateData(myJson.states.sort((a, b) => (a.state).toLowerCase() > (b.state).toLowerCase() ? 1:-1).map((state)=>(
                {
                    value: state.state,
                    label: state.state,
                    items: state.districts
                }
            )))
          })
      }

    

    const updateNewState = (value) =>{

      setState(value)
    }

    
    useEffect(() => { 
        setSelectedDistrict("")
        setFilterState(state)
    }, [state])

    useEffect(() => {
      
      setFilterCity(selectedDistrict)
    }, [selectedDistrict])



    return (
        <div>
            <Dropdown options={stateData} placeholder="Select a State" onChange={(selected)=>{updateNewState(selected.value)}} className={styles.sBox}/>
            {
            
            (state === "Andaman and Nicobar island (UT)" || state === "Ladakh (UT)") ? null : (<SearchDistrict selectedDistrict={selectedDistrict} setSelectedDistrict={setSelectedDistrict} stateData={stateData} state={state}/>)

            }
        </div>
    )
}

export default SearchBox
